import React, {useState, useEffect, useRef} from "react";
import { MainPage } from "./Components/ChatPage/MainPage";
import { layoutProps } from "./Components/ChatPage/Layout/Layout";
import {sendStatistics} from "./services/dataColectorService";
import {logDebug, logError} from "./utils/logger";
import {useAppContext} from "./AppDataContext";
import FloatingPage from "./Components/ChatPage/FloatingPage";
import {getDeviceType} from "./utils/systemInfo";
import {deviceType} from "./constants";



export interface authProps extends layoutProps{
  userId: string,
  error_message?: string,
  should_present_legal_banner: boolean,
  client_id: string,
  client_token: string,
  article_index: string|undefined,
  follow_up_question: string|undefined
  proxy: string|undefined,
  welcome_message:any
}


export const App: React.FC = (
    // { userId, logourl, badgeurl, error_message, should_present_legal_banner, client_id, client_token ,article_index, proxy,follow_up_question,welcome_message}
) => {
 const bottomRef = useRef<HTMLDivElement>(null);
 let AppDataContext =  useAppContext() // Use the context hook to get the context value
  useEffect(() => {
  let sessionStartTime: number;
  // Record the start time of the session
  sessionStartTime = Date.now();
  logDebug("Session started at:", new Date(sessionStartTime));

  const handleBeforeUnload = () => {
    // Record the end time of the session
    const sessionEndTime = Date.now();
    const sessionDurationSeconds = (sessionEndTime - sessionStartTime) / 1000; // Convert to seconds

    // Convert seconds to hours, minutes, and seconds
    const hours = Math.floor(sessionDurationSeconds / 3600); // 3600 seconds in an hour
    const minutes = Math.floor((sessionDurationSeconds % 3600) / 60); // Remaining seconds to minutes
    const seconds = sessionDurationSeconds % 60; // Remaining seconds

    const sessionDuration =
      `${hours.toString().padStart(2,'0')}:${minutes.toString().padStart(2,'0')}:${seconds.toString().padStart(2,'0')}`;
    logDebug("Session ended at:", new Date(sessionEndTime));
    logDebug("Session duration:", sessionDuration);
    //send the session duration to an analytics server
(async () => {
  await sendStatistics(AppDataContext.proxy, AppDataContext.client_id, AppDataContext.userId, AppDataContext.client_token, { 'CHAT_CLOSE_CLICKED': 1 }, false, 0, "end_of_session");
  await sendStatistics(AppDataContext.proxy, AppDataContext.client_id, AppDataContext.userId, AppDataContext.client_token, { 'SESSION_LIFE_TIME': sessionDurationSeconds }, false);

  // Add a short sleep to ensure the request is sent before the window closes
  setTimeout(() => {}, 100);
})();};

  // Set up event listeners
  window.addEventListener("beforeunload", handleBeforeUnload);

  // Cleanup event listeners
  return () => {
    window.removeEventListener("beforeunload", handleBeforeUnload);
  };
}, []);

 //inherit background for body from parent site if floating widget is loaded
   useEffect(() => {
    if (AppDataContext.language_for_widget) {
      // Remove body background
      document.body.style.background = 'inherit';

      // Remove --backgroundClr1 from :root
      const rootStyle = document.documentElement.style;
      rootStyle.removeProperty('--backgroundClr1');
    }
  }, [AppDataContext.language_for_widget]);

  // logDebug(error_message, " - error_message");
  if (!AppDataContext.proxy){
    AppDataContext.proxy = process.env.REACT_APP_MESSAGES_SERVER;
    logDebug('proxy changed APP', AppDataContext.proxy);
  }
  if(AppDataContext.error_message){
    return <div>
      Error occur:
      {AppDataContext.error_message}
    </div>
  }


  return (
    <>
      {AppDataContext.language_for_widget?
          (<FloatingPage/>
          ):(
      <MainPage userId={AppDataContext.userId}
                client_id={AppDataContext.client_id}
                logourl={AppDataContext.logourl}
                badgeurl={AppDataContext.badgeurl}
                should_present_legal_banner={AppDataContext.should_present_legal_banner}
                client_token={AppDataContext.client_token}
                article_index={AppDataContext.article_index}
                follow_up_question={AppDataContext.follow_up_question}
                proxy={AppDataContext.proxy}
                welcome_message={AppDataContext.welcome_message}
      />
        )}
        {getDeviceType() === deviceType.mobile && <div ref={bottomRef} />}
    </>
  );
}
export default App;